"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Field, Shell } from "@/features/home-v2/form/Form";
import { AmountCard, TokenChip } from "@/features/wallet/v2/dialogs/kit";
import { useListForSale, type ListForSaleProps } from "../../flows/useListForSale";
import { CurrencyList, CurrencyRow } from "./CurrencyPick";
import { FlowDialog } from "./FlowDialog";

/** List for sale, in v2 — every rule is `useListForSale`'s (the legacy `ListForSaleFlow`). */
export default function ListDialog(props) {
  const $ = _c(50);
  const f = useListForSale(props);
  const isFa = props.lang === "fa";
  let t0;
  if ($[0] !== isFa) {
    t0 = (fa, en) => isFa ? fa : en;
    $[0] = isFa;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t = t0;
  const [picking, setPicking] = useState(false);
  let t1;
  if ($[2] !== f.currencies || $[3] !== f.selectedCurrencyId) {
    t1 = f.currencies.find(c => String(c.id) === f.selectedCurrencyId)?.image;
    $[2] = f.currencies;
    $[3] = f.selectedCurrencyId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const image = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setPicking(true);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== f.currencies || $[7] !== f.currencyReason || $[8] !== f.selectedCurrencyId || $[9] !== isFa) {
    t3 = <CurrencyRow currencies={f.currencies} value={f.selectedCurrencyId} reason={f.currencyReason} onOpen={t2} isFa={isFa} />;
    $[6] = f.currencies;
    $[7] = f.currencyReason;
    $[8] = f.selectedCurrencyId;
    $[9] = isFa;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t("\u0642\u06CC\u0645\u062A \u0647\u0631 \u0648\u0627\u062D\u062F", "Price per item");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== f.symbol || $[14] !== image || $[15] !== props.networkLabel) {
    t5 = <TokenChip image={image} symbol={f.symbol} placeholder={props.networkLabel} />;
    $[13] = f.symbol;
    $[14] = image;
    $[15] = props.networkLabel;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = f.priceError ? "error" : undefined;
  let t7;
  if ($[17] !== f.price || $[18] !== f.priceError || $[19] !== f.setPrice || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <AmountCard label={t4} value={f.price} onChange={f.setPrice} side={t5} message={f.priceError} tone={t6} />;
    $[17] = f.price;
    $[18] = f.priceError;
    $[19] = f.setPrice;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t) {
    t8 = t("\u062A\u0639\u062F\u0627\u062F", "Quantity");
    $[24] = t;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== f) {
    t9 = e => f.setQuantity(e.target.value);
    $[26] = f;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = Boolean(f.quantityError) || undefined;
  let t11;
  if ($[28] !== f.quantity || $[29] !== t10 || $[30] !== t9) {
    t11 = <Shell ltr={true}><input id="nd-list-qty" type="text" inputMode="numeric" autoComplete="off" value={f.quantity} onChange={t9} aria-invalid={t10} /></Shell>;
    $[28] = f.quantity;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== f.quantityError || $[33] !== t11 || $[34] !== t8) {
    t12 = <Field id="nd-list-qty" label={t8} required={true} error={f.quantityError}>{t11}</Field>;
    $[32] = f.quantityError;
    $[33] = t11;
    $[34] = t8;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t3 || $[38] !== t7) {
    t13 = <>{t3}{t7}{t12}</>;
    $[36] = t12;
    $[37] = t3;
    $[38] = t7;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  const input = t13;
  let t14;
  if ($[40] !== f.currencies || $[41] !== f.selectedCurrencyId || $[42] !== f.setSelectedCurrencyId || $[43] !== isFa || $[44] !== picking) {
    t14 = picking ? <CurrencyList currencies={f.currencies} value={f.selectedCurrencyId} onPick={f.setSelectedCurrencyId} onBack={() => setPicking(false)} isFa={isFa} /> : undefined;
    $[40] = f.currencies;
    $[41] = f.selectedCurrencyId;
    $[42] = f.setSelectedCurrencyId;
    $[43] = isFa;
    $[44] = picking;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  const overlay = t14;
  let t15;
  if ($[46] !== f.model || $[47] !== input || $[48] !== overlay) {
    t15 = <FlowDialog m={f.model} input={input} overlay={overlay} />;
    $[46] = f.model;
    $[47] = input;
    $[48] = overlay;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
}